import { SessionStateIcon } from "@/components/SessionCancelSetting";
import { CheckCircle2, Coins, XCircle, UserX, CalendarCheck, HelpCircle } from "lucide-react";

const ICONS = {
  asistio: CheckCircle2, cancelo_con_sesion: Coins, cancelo_sin_sesion: XCircle,
  no_asistio: UserX, confirmada: CalendarCheck, sin_confirmar: HelpCircle,
};

export function StateIcon({ state, testId }) {
  return <SessionStateIcon state={state} icon={ICONS[state] || HelpCircle} testId={testId} />;
}

export function StateLegend() {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="session-state-legend">
      {Object.keys(ICONS).map((k) => <StateIcon key={k} state={k} testId={`legend-${k}`} />)}
    </div>
  );
}
